import React, { type ReactElement } from 'react'
import { Form, Input } from 'antd'
import { connect } from 'react-redux'
import {
    type RegisterInterface,
    type HomeStateProps,
} from '../../../../../../Types/Client/RegisteredClients/Corporate'

const RegisterAddressForm = (props: RegisterInterface): ReactElement => {
    return (
        <>
            <Form.Item label="Address 1" name="regaddress1">
                <Input disabled />
            </Form.Item>
            <Form.Item label="Address 2" name="regaddress2">
                <Input disabled />
            </Form.Item>
            <Form.Item label="Town" name="regtown">
                <Input disabled />
            </Form.Item>
            <Form.Item label="Country" name="regcountry">
                <Input disabled />
            </Form.Item>
            <Form.Item label="Post Code" name="regpostcode">
                <Input disabled />
            </Form.Item>
        </>
    )
}

const mapStateToProps = (state: any): HomeStateProps => {
    return {
        categoryDropDownList: state.initial.categoryDropDownList,
        countryList: state.common.countryList,
        corporateTaps: state.client.corporateTaps,
    }
}

export default connect(mapStateToProps)(RegisterAddressForm)
